module.exports = "table tbody tr td:last-child {\n  white-space: nowrap;\n  width: 10%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/aircrafts/list/aircrafts.component.css
// module id = ./src/app/aircrafts/list/aircrafts.component.css
// module chunks = main